/* ============================================================================
   Connexion à nos 2 environnements — shared behaviour
   Idempotent + document-level delegation so it works no matter which section
   loaded it and survives Shopify theme-editor partial re-renders.
     - Formation filter (Code linguistique / Rédaction) via <html data-nd-formation>
     - "Copier" buttons (clipboard + fallbacks + aria-live confirmation)
     - Accessible image lightbox (keyboard open, focus trap, Escape, focus restore)
     - Support-ticket form (validation + Shopify + HubSpot, inline success)
   ============================================================================ */
(function () {
  if (window.__ndConnexionInit) return;
  window.__ndConnexionInit = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  /* ---- Formation filter --------------------------------------------------- */
  function selectFormation(name) {
    if (name !== 'code' && name !== 'redaction') return;
    document.documentElement.setAttribute('data-nd-formation', name);
    document.querySelectorAll('[data-nd-tab]').forEach(function (btn) {
      var on = btn.getAttribute('data-nd-tab') === name;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  /* ---- Copy buttons ------------------------------------------------------- */
  function announce(btn, msg) {
    var live = btn.parentNode && btn.parentNode.querySelector('.nd-copied-live');
    if (live) {
      live.textContent = msg;
      setTimeout(function () { live.textContent = ''; }, 1600);
    }
    var label = btn.querySelector('.nd-copy-label') || btn;
    var original = label.getAttribute('data-original') || label.textContent;
    label.setAttribute('data-original', original);
    label.textContent = msg;
    setTimeout(function () { label.textContent = original; }, 1600);
  }

  function legacyCopy(text) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      var ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch (e) { return false; }
  }

  function handleCopy(btn) {
    var text = btn.getAttribute('data-nd-copy') || '';
    function done() { announce(btn, 'Copié !'); }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done).catch(function () {
        if (legacyCopy(text)) done();
        else selectUrlText(btn);
      });
    } else if (legacyCopy(text)) {
      done();
    } else {
      selectUrlText(btn); // final fallback: select the visible address for manual Ctrl-C
    }
  }

  function selectUrlText(btn) {
    var describedBy = btn.getAttribute('aria-describedby');
    var urlEl = describedBy && document.getElementById(describedBy);
    if (!urlEl) urlEl = btn.parentNode && btn.parentNode.querySelector('.nd-url');
    if (!urlEl || !window.getSelection) return;
    var range = document.createRange();
    range.selectNodeContents(urlEl);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    announce(btn, 'Sélectionné');
  }

  /* ---- Lightbox ----------------------------------------------------------- */
  var lb, lbImg, lbClose, lastFocused = null;

  function buildLightbox() {
    if (document.querySelector('.nd-lightbox')) {
      lb = document.querySelector('.nd-lightbox');
      lbImg = lb.querySelector('.nd-lb-img');
      lbClose = lb.querySelector('.nd-lb-close');
      return;
    }
    lb = document.createElement('div');
    lb.className = 'nd-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Image agrandie');
    lb.setAttribute('aria-hidden', 'true');
    lb.innerHTML =
      '<button type="button" class="nd-lb-close" aria-label="Fermer">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
        'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
        '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>' +
      '</button>' +
      '<img class="nd-lb-img" src="" alt="">';
    document.body.appendChild(lb);
    lbImg = lb.querySelector('.nd-lb-img');
    lbClose = lb.querySelector('.nd-lb-close');
    lb.addEventListener('click', function (e) { if (e.target !== lbImg) closeLightbox(); });
    lbClose.addEventListener('click', closeLightbox);
  }

  function openLightbox(src, alt) {
    buildLightbox();
    lastFocused = document.activeElement;
    lbImg.src = src;
    lbImg.alt = alt || '';
    lb.classList.add('is-open');
    lb.setAttribute('aria-hidden', 'false');
    if (lbClose) lbClose.focus();
  }

  function closeLightbox() {
    if (!lb || !lb.classList.contains('is-open')) return;
    lb.classList.remove('is-open');
    lb.setAttribute('aria-hidden', 'true');
    lbImg.src = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  /* ---- Support form ------------------------------------------------------- */
  function isValidEmail(email) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email); }

  function readCookie(name) {
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : '';
  }

  function sendToShopify(pathname, data) {
    var body = new URLSearchParams();
    body.set('form_type', 'contact');
    body.set('utf8', '✓');
    body.set('contact[name]', data.firstname);
    body.set('contact[email]', data.email);
    body.set('contact[objet_demande]', data.objet);
    body.set('contact[body]', data.message);
    return fetch(pathname, {
      method: 'POST',
      body: body.toString(),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
  }

  function sendToHubSpot(portal, guid, data, map) {
    var url = 'https://api.hsforms.com/submissions/v3/integration/submit/' + portal + '/' + guid;
    var fields = [];
    function add(prop, val) { if (prop && val) fields.push({ name: prop, value: val }); }
    add(map.email, data.email);
    add(map.firstname, data.firstname);
    add(map.message, data.message);
    add(map.objet, data.objet);
    var payload = { fields: fields, context: { pageUri: window.location.href, pageName: document.title } };
    var hutk = readCookie('hubspotutk');
    if (hutk) payload.context.hutk = hutk;
    return fetch(url, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: { 'Content-Type': 'application/json' }
    }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r; });
  }

  // Best-effort Customer.io submit via a hidden form + iframe (rendered only when a Form ID is set).
  // Fire-and-forget: there's no redirect here, so the cross-origin submit completes in the background.
  function sendToCustomerIo(scope, data) {
    var cioForm = scope.querySelector('.nd-cio-form');
    var cioIframe = scope.querySelector('.nd-cio-iframe');
    if (!cioForm || !cioIframe) return;
    try {
      var set = function (sel, val) { var el = cioForm.querySelector(sel); if (el) el.value = val || ''; };
      set('.nd-cio-email', data.email);
      set('.nd-cio-firstname', data.firstname);
      set('.nd-cio-message', data.message);
      set('.nd-cio-objet', data.objet);
      set('.nd-cio-formname', 'connexion-aide');
      set('.nd-cio-pagesource', document.title);
      var settled = false;
      function done() { if (settled) return; settled = true; cioIframe.removeEventListener('load', done); }
      cioIframe.addEventListener('load', done);
      setTimeout(done, 3000);
      cioForm.submit();
    } catch (e) { /* best-effort — never blocks the user */ }
  }

  function setInvalid(input, on) {
    if (!input) return;
    if (on) {
      input.setAttribute('aria-invalid', 'true');
      var card = input.closest('.nd-form-card');
      var err = card && card.querySelector('.nd-msg.err');
      if (err && err.id) input.setAttribute('aria-describedby', err.id);
    } else {
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
    }
  }

  function handleSubmit(form) {
    var okBox = form.parentNode.querySelector('.nd-msg.ok');
    var errBox = form.parentNode.querySelector('.nd-msg.err');
    var btn = form.querySelector('.nd-submit');
    var honey = form.querySelector('[name="nd_company_website"]');
    var firstInput = form.querySelector('[name="firstname"]');
    var emailInput = form.querySelector('[name="email"]');
    var msgInput = form.querySelector('[name="message"]');
    var confirmInput = form.querySelector('[name="verifications"]');
    var confirmWrap = form.querySelector('.nd-checkbox');

    okBox.hidden = true;
    errBox.hidden = true;
    if (honey && honey.value) return; // bot

    [firstInput, emailInput, msgInput].forEach(function (f) { setInvalid(f, false); });
    if (confirmWrap) confirmWrap.classList.remove('is-invalid');
    if (confirmInput) confirmInput.removeAttribute('aria-invalid');

    var first = (firstInput.value || '').trim();
    var email = (emailInput.value || '').trim();
    var msg = (msgInput.value || '').trim();

    if (!first || !email || !msg || !isValidEmail(email)) {
      errBox.textContent = !isValidEmail(email) && email && first && msg
        ? 'Veuillez entrer une adresse courriel valide (ex : nom@domaine.com).'
        : 'Merci de remplir le prénom, le courriel et la description.';
      errBox.hidden = false;
      var firstInvalid = null;
      if (!first) { setInvalid(firstInput, true); firstInvalid = firstInvalid || firstInput; }
      if (!email || !isValidEmail(email)) { setInvalid(emailInput, true); firstInvalid = firstInvalid || emailInput; }
      if (!msg) { setInvalid(msgInput, true); firstInvalid = firstInvalid || msgInput; }
      if (firstInvalid) firstInvalid.focus();
      return;
    }

    if (confirmInput && !confirmInput.checked) {
      errBox.textContent = 'Merci de confirmer que tu as effectué les vérifications de base avant de nous écrire.';
      errBox.hidden = false;
      if (confirmWrap) confirmWrap.classList.add('is-invalid');
      confirmInput.setAttribute('aria-invalid', 'true');
      if (errBox.id) confirmInput.setAttribute('aria-describedby', errBox.id);
      confirmInput.focus();
      return;
    }

    var portal = (form.getAttribute('data-nd-portal') || '').trim();
    var guid = (form.getAttribute('data-nd-guid') || '').trim();
    var supportEmail = (form.getAttribute('data-nd-support-email') || '').trim();
    var objet = form.getAttribute('data-nd-objet') || '';
    var scope = form.closest('.nd-access') || document;
    var hsMap = {
      email:     form.getAttribute('data-nd-hs-email')     || 'email',
      firstname: form.getAttribute('data-nd-hs-firstname') || 'firstname',
      message:   form.getAttribute('data-nd-hs-message')   || 'message',
      objet:     form.getAttribute('data-nd-hs-objet')     || ''
    };

    var fullMessage = msg +
      "\n\n— L'étudiant confirme avoir suivi les conseils de base (navigateur Chrome à jour, cookies activés, VPN désactivé).";
    var data = { firstname: first, email: email, message: fullMessage, objet: objet };

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Envoi en cours…';

    function success() {
      form.hidden = true;
      okBox.hidden = false;
      if (okBox.focus) { okBox.setAttribute('tabindex', '-1'); okBox.focus(); }
    }
    function failure() {
      btn.disabled = false;
      btn.textContent = originalText;
      errBox.innerHTML = supportEmail
        ? "Oups, l'envoi a échoué. Réessaie dans un instant, ou écris-nous à <strong>" + supportEmail + '</strong>.'
        : "Oups, l'envoi a échoué. Réessaie dans un instant.";
      errBox.hidden = false;
    }

    // Best-effort channels (swallowed — never block or change the success/error UX).
    sendToShopify(window.location.pathname, data).catch(function () {});
    sendToCustomerIo(scope, data);

    if (portal && guid) {
      // HubSpot is the gating channel when configured: surface real failures.
      sendToHubSpot(portal, guid, data, hsMap).then(success).catch(failure);
    } else {
      // No HubSpot GUID yet → optimistic success via the Shopify/CIO paths.
      success();
    }
  }

  /* ---- Wire up (delegated) ------------------------------------------------ */
  function init() {
    document.addEventListener('click', function (e) {
      var tab = e.target.closest && e.target.closest('[data-nd-tab]');
      if (tab) { selectFormation(tab.getAttribute('data-nd-tab')); return; }

      var copy = e.target.closest && e.target.closest('[data-nd-copy]');
      if (copy) { e.preventDefault(); handleCopy(copy); return; }

      var zoom = e.target.closest && e.target.closest('[data-nd-zoom-src]');
      if (zoom) {
        e.preventDefault();
        openLightbox(zoom.getAttribute('data-nd-zoom-src'), zoom.getAttribute('data-nd-zoom-alt'));
        return;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (!lb || !lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') { closeLightbox(); return; }
      if (e.key === 'Tab') { e.preventDefault(); if (lbClose) lbClose.focus(); } // single-stop focus trap
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('.nd-ticket-form');
      if (!form) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      handleSubmit(form);
    });
  }

  ready(init);
})();
